import React, { FC } from 'react';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import { scale } from '@components/frame';
import { isPhone, isWeb } from '@helpers';
import { StyleProp, View, ViewStyle } from 'react-native';
import { ColorFunction } from '@styles/colors/types';
import { ICON_BUTTON_PADDING } from '@v2/pages/common/constants/base.constants';
import { useManageFavoriteButton } from './hooks/useManageFavoriteButton';

export interface FavoriteButtonProps {
  C: ColorFunction;
  bg?: string;
  iconColor?: string;
  style?: StyleProp<ViewStyle>;
  scopeId: number | null | undefined;
  scopeReferenceId: number | null | undefined;
  /** Optional context-key override forwarded to `useManageFavoriteButton`. */
  contextKey?: string | null;
}

const FavoriteButton: FC<FavoriteButtonProps> = ({
  C,
  style,
  scopeId,
  scopeReferenceId,
  contextKey,
  bg = 'Button/Light/Only Text',
  iconColor: _iconColor,
}) => {
  const { isFavorite, onButtonPress } = useManageFavoriteButton({ scopeId, scopeReferenceId, contextKey });

  const iconColor = _iconColor || (isPhone ? 'Link/Light/Primary' : isFavorite ? 'Label/Light/Primary' : 'Label/Light/Tertiary');

  return (
    <TouchableElement onPress={onButtonPress}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              backgroundColor: C(pressHoverColor(bg)),
              padding: scale(ICON_BUTTON_PADDING),
              borderRadius: scale(18),
            },
            isWeb && { outline: 'none' },
            style,
          ]}
        >
          <Svg icon={isFavorite ? 'starSelected' : 'starUnselected'} width={scale(21)} height={scale(21)} color={iconColor} />
        </View>
      )}
    </TouchableElement>
  );
};

export default FavoriteButton;
